<div class="exception">
    <h1>Not found</h1>
    <p class="mt-2">ไม่พบหน้าที่คุณต้องการ</p>
    <p>
        กลับไป <a href="/" class="text-primary">หน้าแรก</a>
        หรือกลับไป <a href="javascript:history.back()" class="text-primary">หน้าที่แล้ว</a>
    </p>
</div>